module.exports = __webpack_public_path__ + "img/banner@2x.f8de21ee.jpg";